module.exports = __webpack_public_path__ + "media/img/hartmannbund-list-style-image-d4d2ccf2f2438d4f50fc0cd3b2efa016.svg";